function getProducts(items) {
    const products = [];
    for(const item of items) {
        const product = $.ajax({dataType: "json", url: '/products/' + item.handle + '.js', async: false}).responseJSON;
        if (product) products.push(product);
    }
    return products;
}

function filterReservedProducts(products) {
    const results = [];
    for (const product of products) {
        if (isReservedProduct(product)) results.push(product);
    }
    return results;
}

function filterGeneralProducts(products) {
    const results = [];
    for (const product of products) {
        if(!isReservedProduct(product)) {
            if(!isUnconditionalProduct(product)) {
                results.push(product);
            }
        }
    }
    return results;
}

function isReservedProduct(product) {
    let result = false;
    for(const tag of product['tags']) {
        if (tag === 'reserved') {
            result = true;
            break;
        }
    }
    return result;
}

/**
 * 無条件にカートに追加できるタイプ
 */
const unconditionalTypes = ["hypersphere"];
function isUnconditionalProduct(product) {
    let result = false;
    for(const unconditionalType of unconditionalTypes) {
        if (product.type.toLowerCase().indexOf(unconditionalType) !== -1) {
            result = true;
            break;
        }
    }
    return result;
}

// 閲覧中のページの商品をカートに追加できる場合はtrue
function checkEnableAddToCart(isReserved, isExceptionalType) {
    const cartItems = $.ajax({dataType: "json", url: '/cart.js', async: false}).responseJSON.items;

    let result = false;
    if (cartItems) {
        const products = getProducts(cartItems);
        const reservedProducts = filterReservedProducts(products);
        const generalProducts = filterGeneralProducts(products);

        if(isReserved) {
            /**
             * 予約商品を追加する場合
             *
             * カートに通常商品を含まない => true
             * それ以外 => false
             */
            result = generalProducts.length === 0;
        } else if(isExceptionalType) {
            /**
             * 無条件商品を追加する場合
             *
             * すべての条件でtrue
             */
            result = true;
        } else {
            /**
             * 通常商品を追加する場合
             *
             * カートに予約商品を含まない => true
             * それ以外 => false
             */
            result = reservedProducts.length === 0;
        }
    }

    if(!result) {
        alert("予約商品と通常商品を同時にカートに入れることは出来ません");
    }

    return result;
}

function checkCartItems() {
    const cartItems = $.ajax({dataType: "json", url: '/cart.js', async: false}).responseJSON.items;

    let result = true;
    if (cartItems) {
        const products = getProducts(cartItems);
        const reservedProducts = filterReservedProducts(products);
        const generalProducts = filterGeneralProducts(products);

        /**
         * 予約商品を含む場合
         *
         * 通常商品(特例を除く)が0個 => true
         */
        if(reservedProducts.length) {
            result = generalProducts.length === 0;
        }
    }

    if(!result) {
        alert('予約商品と通常商品を同時に購入することが出来ません');
    }

    return result;
}

/* ================ EVENT PAGE ================ */
const filterButtons = document.querySelectorAll('[data-filter]');
const categoryContents = document.querySelectorAll('[data-category]');

filterButtons.forEach((filterButton) => {
  filterButton.addEventListener('click', buttonSwitch);
  filterButton.addEventListener('click', categoryFilter);
});

function buttonSwitch() {
  filterButtons.forEach((filterButton) => {
    filterButton.classList.remove("is-active");
    this.classList.add('is-active');
  });
}

function categoryFilter() {
  const buttonCategory = this.dataset.filter;
  const targetContents = document.querySelectorAll('[data-category="' + buttonCategory + '"]');

  categoryContents.forEach((categoryContent) => {

    categoryContent.animate([{
        opacity: 0
      },
      {
        opacity: 1
      }
    ], {
      duration: 600,
      fill: 'forwards'
    });

    if (buttonCategory == 'all') {
      categoryContent.classList.add('is-show');
    } else {
      categoryContent.classList.remove("is-show");
      targetContents.forEach((targetContent) => {
        targetContent.classList.add('is-show');
      });
    }
  });
}